// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__11WS4","loaderOuter":"PageOverlayLoader_loaderOuter__pcIKg"};